export default __webpack_public_path__ + "static/media/step-email.01415a70.svg";